import {logout, getTokens, getUser} from './ForgerockService.ts'

export const hybrisLogin = async (accessToken, contextPath, loginReferer) => {
    if (window.ACC.config.forgerockFetchRoutingRegionV2) {
        const routingRegion = await fetchRoutingRegion();

        fetch(`${contextPath}/forgerock/authenticate/login?loginReferer=${encodeURIComponent(loginReferer)}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "AuthToken": accessToken,
                "RoutingRegion": routingRegion,
            },
        }).then((response) => {
            if (response.status === 200) {
                return response.json();
            }
        }).then((response) => {
            if (response) {
                window.location.href = response.redirectUrl;
            }
        });
    } else {
        fetch(`${contextPath}/forgerock/authenticate/login?loginReferer=${encodeURIComponent(loginReferer)}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "AuthToken": accessToken,
            },
        }).then((response) => {
            if (response.status === 200) {
                return response.json();
            }
        }).then((response) => {
            if (response) {
                window.location.href = response.redirectUrl;
            }
        }).catch((error) => {
           console.log(error);
           window.forgerockLogout();
         });
    }
};

async function fetchRoutingRegion() {
    const email = (await getUser()).email;

    return fetch(`${window.location.origin}/v1/identity/lookup/region/emailaddress/${email}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    })
        .then((response) => {
            if (response.status !== 200) {
                throw new Error('Fetching user region failed');
            }
            return response.json();
        })
        .then((response) => {
            if (response && response.routingRegion) {
                let cookieValue;
                if (Array.isArray(response.routingRegion)) {
                    [cookieValue] = response.routingRegion;
                } else {
                    cookieValue = response.routingRegion;
                }
                document.cookie = `routingRegion=${cookieValue};path=/`;
                return cookieValue;
            }
            return null;
        })
        .catch((error) => {
            console.error("Error fetching routing region:", error);
            return null;
        });
}

export const autoLogin = async (contextPath, loginReferer) => {
    try {
        const tokens = await getTokens();
        if (tokens) {
            hybrisLogin(tokens.accessToken, contextPath, loginReferer);
        }
    } catch (err) {
        console.error(err);
    }
};

export const autoLogout = async (contextPath) => {
    const forgerockSessionValid = await isForgerockSessionValid();
    if (!forgerockSessionValid) {
        window.location.href = `${contextPath}/logout`;
    }
};

export const isForgerockSessionValid = async () => {
    try {
        const tokens = await getTokens();
        if (tokens) {
            return true;
        }
    } catch (err) {
        return false;
    }
}

export const callForgerockLogout = async () => {
    await logout();
};
